import React from 'react';
import Header from 'js/components/Header';

export default () => {
    return <Header />;
};
